/* Brief 3.5 PR 7-A — mechanical file split. Lifted verbatim from
   AdminMerchantDetail.jsx so the lint gate (PR 7-B) runs on small,
   focused files. No behaviour change. */
import { History } from "lucide-react";
import { CollapsibleSection, fmtDate } from "./primitives";

// ---------- F. Activity timeline ----------

export function ActivityTimeline({ activity }) {
  const items = activity?.items || [];
  // Default-collapsed per Option A simplification — reviewers can open
  // it on demand; previously this default-expanded for active review
  // states (awaiting_documents / submitted / under_review) but the
  // signal-to-noise on a long timeline didn't justify the screen real
  // estate as the unified detail page grew.
  return (
    <CollapsibleSection icon={History} title={`Activity timeline · ${items.length} events`} testId="merchant-section-activity" defaultOpen={false}>
      <ol className="relative ml-2.5 border-l border-white/[0.06] pl-5 space-y-4">
        {items.length === 0 && (
          <li className="text-[12.5px] text-zinc-500" data-testid="activity-empty">No activity yet.</li>
        )}
        {items.map((e, i) => (
          <li
            key={`${e.timestamp}-${i}`}
            className="relative"
            data-testid={`activity-row-${i}`}
          >
            <span className={`absolute -left-[28px] top-1 inline-flex h-2.5 w-2.5 rounded-full ${
              e._kind === "status" ? "bg-cyan-400" :
              e.actor_type === "admin" ? "bg-violet-400" :
              e.actor_type === "system" ? "bg-zinc-500" : "bg-emerald-400"
            }`} />
            <div className="text-[11.5px] text-zinc-500">{fmtDate(e.timestamp)}</div>
            <div className="mt-0.5 text-[13px] text-white">
              {/* Brief 3.5 PR 5 — server-rendered "What happened?" summary.
                  Fallback for legacy rows without `summary` retains
                  the old enum display so historical entries still read. */}
              <span data-testid={`activity-row-summary-${i}`}>
                {e.summary || (
                  e._kind === "status"
                    ? `Status: ${e.metadata?.from_status} → ${e.metadata?.to_status}`
                    : `${e.action} · ${e.entity}`
                )}
              </span>
              <span className="text-zinc-500"> · </span>
              <span className="text-zinc-400 text-[12px]">{e.actor_email || e.actor_id || e.actor_type}</span>
            </div>
          </li>
        ))}
      </ol>
      {activity?.has_more && (
        <div className="mt-4 text-[12px] text-zinc-500" data-testid="activity-has-more">
          Showing {items.length}. More events available — full audit trail in /admin/merchants/{"{id}"}/audit.
        </div>
      )}
    </CollapsibleSection>
  );
}
